module.exports = __webpack_public_path__ + "img/arrow-left-img.ef5946c7.svg";